import { FirebaseApp, initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  Messaging,
  onMessage,
} from 'firebase/messaging';
import { SocketTreatmentEvents } from 'types';
import { Api } from './api/axios.service';
import { authHeader } from './header.service';

const firebaseConfig = JSON.parse(
  process.env.REACT_APP_FIREBASE_API_KEY as string
);

let firebaseApp: FirebaseApp | null = null;
let messaging: Messaging | null = null;

// Firebase messaging is not supported on Safari https://firebase.google.com/docs/web/environments-js-sdk
export const requestNotificationPermission = async () => {
  try {
    // Initialize Firebase
    firebaseApp = initializeApp(firebaseConfig);
    messaging = getMessaging(firebaseApp);

    if (
      !('Notification' in window) ||
      !('ServiceWorkerRegistration' in window)
    ) {
      alert('As notificações não são permitidas nesse navegador!');
      return;
    }

    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      try {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        });

        // Register to update queue list push notification topic
        subscribeVetToNotificationTopics(
          token,
          SocketTreatmentEvents.TUTOR_TREATMENT_UPDATE_VET_QUEUE
        );
        return token;
      } catch (reason) {}
    }
  } catch (reason) {}
};

export const onMessageListener = () => {
  if (messaging !== null) {
    return new Promise((resolve) => {
      onMessage(messaging as Messaging, (payload) => {
        resolve(payload);
      });
    });
  }
};

/**
 * Register vet on firebase messaging topics
 *
 * @param {string} topic
 * @return {*}
 */
const subscribeVetToNotificationTopics = (token: string, topic: string) => {
  return Api.put(
    `/vet/subscribe-to-notifications`,
    {
      token,
      topic,
    },
    {
      headers: authHeader(),
    }
  );
};

